module.exports = __webpack_public_path__ + "static/a-field-guide-to-getting-lost-7f8b36d3317a689f1ea916e0beca0611.jpg";